import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getApartmentsRequest, getFilterApartmentsRequest } from "../api/api";

export const fetchAllApartments = createAsyncThunk(
	'apartments/fetchAllApartments',
	async () => {
		const response = await getApartmentsRequest();
		return response;
	}
)

export const updateApartmentsToParams = createAsyncThunk(
	'apartments/getApartments',
	async (params, {dispatch}) => {
		dispatch(setLoading(true));
		const response = await getFilterApartmentsRequest(params);
		dispatch(setLoading(false));

		return response;
	}
)

const initialState = {
	apartments: [],
	roomsCount: 0,
	loading: false,
}

export const apartmentsSlice = createSlice({
	name: 'apartments',
	initialState,
	reducers: {
		addFullApartments: (state, action) => {
			state.apartments.push(action.payload);
		},
		updateApartments: (state, action) => {
			state.apartments = action.payload;
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		}
	},
	extraReducers: {
		[fetchAllApartments.fulfilled]: (state, action) => {
			state.apartments = action.payload.rooms;
			state.roomsCount = action.payload.found_rows;
		},
		[updateApartmentsToParams.fulfilled]: (state, action) => {
			state.apartments = action.payload.rooms;
		},
	}
});

export const { addFullApartments, replaceApartments, setLoading } = apartmentsSlice.actions;

export default apartmentsSlice.reducer;
